export enum ItemId {
  // splus
  SplusWeekRMB1 = 'splus_week_rmb1',
  SplusWeekRMB5 = 'splus_week_rmb5',
  SplusMonthSummer = 'splus_month_summer',
  SplusQuarterSemester = 'splus_quarter_school',
  SplusQuarterActivity = 'splus_quarter_activity',
  SplusQuarterSemester2 = 'splus_quarter_semester',

  SplusYearBigSale = 'splus_year_bigsale',
  SplusYearBigSale78 = 'splus_year_bigsale78',
  SplusYearBigSale88 = 'splus_year_bigsale88',
  SplusYearBigSale95 = 'splus_year_bigsale95',
  SplusYearBigSale97 = 'splus_year_bigsale97',
  SplusYearBigSale98 = 'splus_year_bigsale98',

  SplusYearMiddle = 'splus_year_middle',
  SplusYearXingyuan = 'splus_year_xingyuan',
  SplusYearMiddleCoupon = 'splus_year_middle_coupon',
  SplusYearMiddleCoupon86 = 'splus_year_middle_coupon86',

  Splus2YearsHalloween = 'splus_year_halloween',
  Splus2YearsHalloweenDiff = 'splus_year_repair',

  // splus renew
  SplusRenewMonth = 'splus_renew_month',
  SplusRenewWeekRMB2 = 'splus_renew_week_rmb2',
  SplusRenewWeekRMB5 = 'splus_renew_week_rmb5',
  SplusRenew3DaysFree = 'splus_renew_month5',
  SplusRenew7DaysFree = 'splus_renew_quarter2',
  SplusRenewQuarter3 = 'splus_renew_quarter3',
  SplusRenewMonthSummer = 'splus_renew_month_summer',
  SplusRenewQuarterSemester = 'splus_renew_quarter_school',
  SplusRenewQuarterSemester2 = 'splus_renew_quarter_semester',
  SplusRenewQuarterActivity = 'splus_renew_quarter_activity',

  // splus 课程
  SplusJumpup = 'splus_jumpup',

  // ssplus
  SSplusMonthSummer = 'splus_big_summer',
  SSplusBigMonthRun = 'splus_big_month_run',
  SSplusQuarterSemester = 'splus_big_school',
  SSplusQuarterSemester2 = 'splus_big_semester',
  SSplusBigMonthActivity = 'splus_big_month_activity',
  SSplusBigWeekActivity = 'splus_big_week',

  SSplusYearCoupon188 = 'super_year_coupon',
  SSplusYearCoupon178 = 'super_year_coupon178',
  SSplusYearBigSale148 = 'splus_super_year_bigsale148',
  SSplusYearBigSale158 = 'splus_super_year_bigsale158',
  SSplusYearBigSale165 = 'splus_super_year_bigsale165',
  SSplusYearBigSale167 = 'splus_super_year_bigsale167',
  SSplusYearBigSale168 = 'splus_super_year_bigsale168',

  SSplusYearMiddleCoupon = 'super_year_middle_coupon',
  SSplusYearMiddleCoupon156 = 'super_year_middle_coupon156',

  // ssplus 2years
  SSplus2YearsCoupon248 = 'splus_big_year_coupon248',
  SSplus2YearsCoupon268 = 'splus_big_year_coupon268',
  SSplus2YearsCoupon278 = 'splus_big_year_coupon278',
  SSplus2YearsHalloween = 'splus_big_year_halloween',
  SSplusBigYearCoupon278 = 'splus_big_year_coupon278', // @deprecated - please use SSplus2YearsCoupon278
  SSplus2YearsHalloweenDiff = 'splus_big_year_repair',

  // ssplus renew
  SSplusRenewMonthSummer = 'splus_big_renew_summer',
  SSplusRenewQuarterSemester = 'splus_big_renew_school',
  SSplusRenewQuarterSemester2 = 'splus_big_renew_semester',

  // ssplus upgrade
  SSplusUpgradeYear78 = 'super_year_upgrade78',
  SSplusUpgradeYear58 = 'super_year_upgrade58',
  SSplusUpgradeYear68 = 'super_year_upgrade68',
  SSplusUpgrade2Years118 = 'super_year_upgrade118',
  SSplusUpgradeYearBigSale58 = 'super_year_upgrade58', // @deprecated - please use SSplusUpgradeYear58
  SSplusUpgradeYearBigSale68 = 'super_year_upgrade68', // @deprecated - please use SSplusUpgradeYear68

  // ssplus bundles
  SSplusBundleWeekBoy1 = 'splus_week_boy1',
  SSplusBundleWeekBoy2 = 'splus_week_boy2',
  SSplusBundleWeekGirl1 = 'splus_week_girl1',
  SSplusBundleWeekGirl2 = 'splus_week_girl2',
  SSplusBundleWeekBoy1Coupon = 'splus_week_boy1_coupon',
  SSplusBundleWeekBoy2Coupon = 'splus_week_boy2_coupon',
  SSplusBundleWeekGirl1Coupon = 'splus_week_girl1_coupon',
  SSplusBundleWeekGirl2Coupon = 'splus_week_girl2_coupon',

  // sports course
  SCJumpropePlan8 = 'jump_rope_plan_9.9',
}

export enum ItemType {
  Splus = 'regular',
  SSplus = 'big',
}

export interface ISplus {
  server_time: string
  member_name: string
  member_type: 'regular' | 'big' | 'pure_enjoy'
  is_member: boolean
  is_ad_trial: boolean
  is_pure_enjoy: boolean
  renew_status: boolean
  big_renew_status: boolean
  pure_enjoy_renew_status: boolean
  big_expiration_time: string
  member_expiration_time: string
  pure_enjoy_expiration_time: string

  medal_id: number
  medal_name: string
  medal_picture: string
  mileage: number | null
  today_ttb: boolean

  conversion_config: {
    renew_enabled: boolean
    charge_enabled: boolean
  }
}

export interface ISplusStatus {
  up_730: boolean
  bind_phone: boolean
  member_flag: boolean
  member_remain: boolean
  has_been_member: boolean
  super_member_flag: boolean
  is_member_subscribe: boolean
  is_super_member_subscribe: boolean
}
